import { z } from 'zod'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { dateOrIsoString } from '~/prix/types/date'

export const inventoryObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid().nullish(),
  residence: residenceObject.nullish(),
  equipmentName: z.string().nullish(),
  observation: z.string().nullish(),
  serialNumber: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  clientId: z.number().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  sourceFilter: z.string().nullish(),
})

export type InventoryType = z.infer<typeof inventoryObject>
